import React, { Component } from 'react'
import { Modal, Table, Spin, Button, Image, Tooltip } from 'antd'
import { connect } from 'react-redux'
import { getProductsByCodes, showItemDetail, fetchDiagramDataRequest } from '../../actions'
import { withTranslation } from 'react-i18next'
import { EyeOutlined } from '@ant-design/icons'

class DiagramModal extends Component {
  state = {
    highlightedPosition: null,
  }

  componentDidUpdate(prevProps) {
    if (this.props.diagramData && this.props.diagramData !== prevProps.diagramData) {
      const partNumbers =
        this.props.diagramData.parts && this.props.diagramData.parts.length > 0
          ? this.props.diagramData.parts
              .map((part) => part.number)
              .filter((number) => number != null)
          : []

      if (partNumbers.length > 0) {
        this.props.getProductsByCodes(partNumbers)
      }
    }
  }

  handleSVGHover = (position) => {
    this.setState({ highlightedPosition: position })
  }

  handleSVGMouseLeave = () => {
    this.setState({ highlightedPosition: null })
  }

  buildColumns = () => {
    const { t, isMobile, showItemDetail, productsList } = this.props
    return [
      { title: t('Pos'), dataIndex: 'position', key: 'position' },
      { title: t('Code'), dataIndex: 'number', key: 'number' },
      {
        title: t('Name'),
        dataIndex: 'name',
        key: 'name',
        render: (text, record) => {
          const matchingProduct = productsList.find(
            (product) => product.codigodearticulo == record.number,
          )
          return matchingProduct ? matchingProduct.descripcioncatalogo : text
        },
      },
      { title: t('Cant'), dataIndex: 'quantity', key: 'quantity' },
      {
        key: 'actions',
        render: (_, record) => {
          const matchingProduct = productsList.find(
            (product) => product.codigodearticulo == record.number,
          )
          return matchingProduct ? (
            <Tooltip title={t('View product')} trigger={isMobile ? 'none' : 'hover'}>
              <Button
                type='link'
                icon={<EyeOutlined />}
                onClick={() => {
                  const payload = {
                    show: true,
                    showDealLabel: true,
                    item: { ...matchingProduct },
                  }
                  showItemDetail(payload)
                }}
              />
            </Tooltip>
          ) : null
        },
      },
    ]
  }

  // Override rowClassName to disable row if no matchingProduct
  getRowClassName = (record) => {
    const { productsList } = this.props
    const matchingProduct = productsList.find(
      (product) => product.codigodearticulo == record.number,
    )
    if (!matchingProduct) {
      return 'disabled-row'
    }
    return record.position === this.state.highlightedPosition ? 'ant-table-row-selected' : ''
  }

  render() {
    const { t, visible, onClose, item, loadingDiagramData, diagramData, isMobile } = this.props

    return (
      <Modal
        className='diagram-modal'
        title={
          item && item.codigodearticulo
            ? `${t('Parts diagram')} - ${item.codigodearticulo}`
            : t('Parts diagram')
        }
        open={visible}
        onCancel={onClose}
        footer={null}
        width='80%'
      >
        {loadingDiagramData ? (
          <div style={{ textAlign: 'center', margin: '20px 0' }}>
            <Spin size='large' />
            <div style={{ marginTop: 12 }}>{t('Loading diagram...')}</div>
          </div>
        ) : diagramData && diagramData.parts && diagramData.parts.length > 0 ? (
          <div className='diagram-modal-body'>
            <div className='diagram-modal-table'>
              <Table
                dataSource={diagramData.parts}
                columns={this.buildColumns()}
                pagination={{ pageSize: 10 }}
                rowKey='number'
                rowClassName={this.getRowClassName}
                onRow={(record) => ({
                  onMouseEnter: () => this.handleSVGHover(record.position),
                  onMouseLeave: () => this.handleSVGMouseLeave(),
                })}
                scroll={{ x: isMobile ? 'max-content' : null }}
              />
            </div>
            {diagramData.mediaList && diagramData.mediaList.length > 0 && (
              <div className='diagram-modal-images'>
                {diagramData.mediaList.map((url, index) => {
                  if (!url.endsWith('.svg')) {
                    return (
                      <Image
                        key={index}
                        width={100}
                        height={100}
                        src={url}
                        alt={`Media ${index}`}
                      />
                    )
                  }
                  return null
                })}
              </div>
            )}
            <div className='diagram-modal-svg'>
              {diagramData.svg ? (
                <div
                  style={{ width: '100%', height: '100%' }}
                  dangerouslySetInnerHTML={{ __html: diagramData.svg }}
                  onMouseOver={(e) => {
                    const textElement = e.target.closest('text')
                    if (textElement) {
                      const metadata = Array.from(textElement.children).find(
                        (child) => child.tagName === 'metadata',
                      )
                      if (metadata) {
                        const odmElement = metadata.querySelector('odm')
                        if (odmElement) {
                          const position = odmElement.getAttribute('value')
                          if (position) {
                            this.handleSVGHover(position)
                          }
                        }
                      }
                    }
                  }}
                  onMouseLeave={(e) => {
                    const textElement = e.target.closest('text')
                    if (textElement) {
                      const metadata = Array.from(textElement.children).find(
                        (child) => child.tagName === 'metadata',
                      )
                      if (metadata) {
                        const odmElement = metadata.querySelector('odm')
                        if (odmElement) {
                          this.handleSVGMouseLeave()
                        }
                      }
                    }
                  }}
                />
              ) : (
                <div>Loading SVG...</div>
              )}
            </div>
          </div>
        ) : (
          this.props.onClose()
        )}
      </Modal>
    )
  }
}
const mapStateToProps = ({ products }) => {
  return {
    productsList: products.productsList,
    loadingDiagramData: products.loadingDiagramData,
    diagramData: products.diagramData,
  }
}

const mapDispatchToProps = (dispatch) => ({
  showItemDetail: (payload) => {
    dispatch(showItemDetail(payload))
  },
  getProductsByCodes: (payload) => {
    dispatch(getProductsByCodes(payload))
  },
  fetchDiagramDataRequest: (payload) => {
    dispatch(fetchDiagramDataRequest(payload))
  },
})

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(DiagramModal))
